/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { AuthSwitchOptions, AuthSwitchResponses } from '../models/AuthSwitch'
import {
  authSwitchResponseSchema,
  authSwitchErrorSchema,
  authSwitchBodySchema,
} from '../schemas/authSwitchSchema'

/**
 * @summary Switch the active org/role context (used when opening a user-event in another org). Security gate: the
 * user must hold a role in the target org OR be an active Edu student of it. Re-issues the JWT for the new
 * context. `orgChanged=true` tells the UI to reload the full workspace; the events cache is untouched
 * (cross-role).
 * {@link /api/v4/auth/switch}
 */
export function authSwitch<ThrowOnError extends boolean = true>(
  options: Options<AuthSwitchOptions, ThrowOnError>
): Unwrappable<RequestResult<AuthSwitchResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/switch',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: authSwitchBodySchema,
        response: authSwitchResponseSchema,
        error: authSwitchErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<AuthSwitchResponses, ThrowOnError>>
  )
}
